import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib/helpers/api';
import OrderInService from '@iso/services/OrderService/OrderInService';
import { types, actions } from './reducer';

function* deleteOrderIn({ id }) {
    try {
        yield call(OrderInService.deleteOne, id);
        yield put(actions.deleteOrderInSucceeded(id));
    } catch (error) {
        yield put(actions.deleteOrderInFailed(extractError(error)));
    }
}

function* watchDeleteOrderIn() {
    yield takeEvery(
        types.REQUEST_DELETE_ORDER_IN,
        deleteOrderIn,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteOrderIn),
    ]);
}

export default deleteSaga;
